import { render, staticRenderFns } from "./SetLanguageOrder.vue?vue&type=template&id=431e319a&scoped=true"
import script from "./SetLanguageOrder.vue?vue&type=script&lang=js"
export * from "./SetLanguageOrder.vue?vue&type=script&lang=js"
import style0 from "./SetLanguageOrder.vue?vue&type=style&index=0&id=431e319a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431e319a",
  null
  
)

export default component.exports